import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import colors from '@app/constants/colors';
import footerLinks from '@app/constants/footerLinks';
import { getCookie, setCookie } from '@app/helpers/cookie';
import { Button } from '@app/components';

class Cookie extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isCookieAccepted: getCookie('use_cookie') };
  }

  acceptCookie = () => {
    setCookie('use_cookie', 1);
    this.setState({ isCookieAccepted: getCookie('use_cookie') });
  };

  render() {
    const { isCookieAccepted } = this.state;
    const { locale } = this.props;

    return isCookieAccepted ? false : (
      <CookieContainer>
        <CookieText>
          <FormattedMessage id="cookie.text" />
          &nbsp;
          <a href={footerLinks.infoLinks.policy[locale]} target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="footer.policy" />
          </a>
        </CookieText>
        <Button
          bordered
          labelId="cookie.accept"
          textColor={colors.BUTTERFLY_BUSH}
          backgroundColor={colors.SANDWISP}
          onClick={this.acceptCookie}
        />
      </CookieContainer>
    );
  }
}

Cookie.propTypes = {
  locale: PropTypes.string.isRequired,
};

const mapStateToProps = ({ intl: { locale } }) => ({ locale });

export default connect(mapStateToProps)(Cookie);

const CookieContainer = styled.div`
  position: fixed;
  top: unset;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  min-height: 70px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 1;
  z-index: 9999;
  background-color: rgba(25, 174, 211, 0.95);
  overflow: hidden;
  padding: 10px;
  
  & > * {
    margin: 0 50px;
  }
  
  & button {
    flex: 0 0 250px;
  }
    
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    
    & > * {
      margin: 10px;
    }
     
    & button {
      flex: 1 1 auto;
    }
  }
`;

const CookieText = styled.span`
  color: ${colors.ALICE_BLUE};
  
  & a {
    color: ${colors.ALICE_BLUE};
    text-decoration: underline;
    
    &:active,
    &:focus,
    &:visited {
      color: ${colors.ALICE_BLUE};
    }
  }
`;
